import moment from 'moment';
import { formatEncounterStatus } from '../../utils/encounterHelper';
import { sanitizeHtmlContent } from 'src/utils';

const EncounterPrintPreview = ({ editedSummary, record }) => {
  const selectedRecord = record;
  const {
    color: selectedRecordColor,
    displayStatus: selectedRecordDisplayStatus,
  } = formatEncounterStatus(selectedRecord);

  return (
    <div>
      <div className="mb-2 p-2 border-solid border">
        <div className="text-[13px] font-medium flex gap-2">
          {selectedRecord?.description}
        </div>
        <div className="text-gray-500 text-[12px] flex flex-col ">
          <div
            className=""
            style={{ color: selectedRecordColor }}
            id={selectedRecordDisplayStatus}
          >
            {selectedRecordDisplayStatus}
          </div>
          <div className="flex">{selectedRecord?.practitioner_name}</div>
          <div>
            {moment(selectedRecord?.created_at).format('MMM Do, YYYY')}{' '}
            {moment(selectedRecord?.created_at).format('h:mm A')}
          </div>
        </div>
      </div>
      {editedSummary?.summary_json ? (
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizeHtmlContent(editedSummary.summary_json),
          }}
        />
      ) : (
        <div>No medical notes for this encounter</div>
      )}
    </div>
  );
};

export default EncounterPrintPreview;
